import { apiSlice } from 'store/slices/api/api-slice';
import { ItemCreatRequest, ItemListResponse } from 'types/product/product-item';

export const creatProductItem = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        addProductItem: builder.mutation<void, ItemCreatRequest>({
            query: (itemCreatRequest: ItemCreatRequest) => ({
                url: '/product/save-product-item/' + itemCreatRequest.productId,
                method: 'POST',
                body: itemCreatRequest,
            }),
        }),

        updateProductItem: builder.mutation<void, ItemCreatRequest>({
            query: (itemCreatRequest: ItemCreatRequest) => ({
                url:
                    '/product/update-product-item/' +
                    itemCreatRequest.productId,
                method: 'PUT',
                body: itemCreatRequest,
            }),
        }),

        itemList: builder.query<ItemListResponse[], string>({
            query: (productId: string) => ({
                url: `/product/product-items/` + productId,
                method: 'GET',
            }),
        }),

        productItemData: builder.query<ItemListResponse, string>({
            query: (params) => ({
                url: `/product/product-item/` + params,
                method: 'GET',
            }),
        }),

        itemDelete: builder.mutation<void, string>({
            query: (id: string) => ({
                url: `/product/delete-product-item/` + id,
                method: 'DELETE',
                header: {},
            }),
        }),
    }),
});

export const {
    useAddProductItemMutation,
    useUpdateProductItemMutation,
    useLazyItemListQuery,
    useProductItemDataQuery,
    useItemDeleteMutation,
} = creatProductItem;
